/**
 * Central API configuration for VedicTools UI.
 *
 * REACT_APP_API_URL is baked in at build time by the CI workflow.
 * Never hardcode localhost as a default for production builds.
 *
 * For developer test dashboards that allow runtime server switching,
 * use getDefaultApiUrl() which picks the right default based on build
 * environment, then falls back to hostname detection.
 */

export const PROD_API_URL =
  process.env.REACT_APP_API_URL ||
  'https://vedictools-server-271345113157.asia-south1.run.app';

export const DEV_API_URL = 'http://localhost:8000';

export const DEFAULT_SERVERS = {
  localhost: DEV_API_URL,
  production: PROD_API_URL,
};

/**
 * Returns the correct default API URL for runtime server-switching UIs.
 * - In a production build (NODE_ENV=production), always returns the prod URL.
 * - In development, returns localhost.
 * - As a last resort, sniffs the hostname (covers e.g. Firebase preview channels).
 */
export const getDefaultApiUrl = () => {
  // process.env.NODE_ENV is 'production' in CI builds (set by react-scripts)
  if (process.env.NODE_ENV === 'production') return PROD_API_URL;
  // Hostname sniff as belt-and-suspenders for non-standard deployments
  const host = window.location.hostname;
  const isRemote =
    !host.includes('localhost') && !host.includes('127.0.0.1') && host !== '';
  return isRemote ? PROD_API_URL : DEV_API_URL;
};
